import { rem } from 'polished';
import styled, { keyframes } from 'styled-components';

const LIGHT_GREY = '#d0d8db';
const SM_BREAKPOINT = 768;

const animLeft = keyframes`
  0% {transform: translate3d(100%, 0, 0)}
  100% {
    transform: translate3d(0)}
`;

export const NotificationContainer = styled.div`
  @media (min-width: ${SM_BREAKPOINT}px) {
    right: ${rem(7)};
    width: ${rem(320)};
    margin: auto;
    left: auto;
  }
  position: fixed;
  top: ${rem(70)};
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 101;
  background: white;
  width: 96%;
  border: ${rem(1)} solid ${LIGHT_GREY};
  border-radius: ${rem(3)};
  box-shadow: 0 ${rem(2)} ${rem(4)} 0 rgba(0, 0, 0, 0.12);
  animation: 0.4s ${animLeft} ease-out 1 forwards;
`;

export const NotificationHeader = styled.div`
  padding: ${rem(12)} ${rem(8)} 0 ${rem(12)};
  border-bottom: ${rem(1)} solid ${LIGHT_GREY};
  text-align: left;
`;

export const ClipThumbnail = styled.div<{ thumbnailUrl: string }>`
  vertical-align: top;
  display: inline-block;
  width: ${rem(80)};
  height: ${rem(60)};
  background: grey url(${(props) => props.thumbnailUrl}) no-repeat center;
  background-size: cover;
  margin-right: ${rem(10)};
`;

export const Header6Wrapper = styled.div`
  display: inline-block;
  width: ${rem(196)};
  margin-bottom: ${rem(-20)};
`;

export const ManageClips = styled.div`
  text-align: right;
  padding: ${rem(12)};
  box-shadow: 0 ${rem(4)} ${rem(10)} ${rem(6)} rgba(0, 0, 0, 0.1);
`;

export const ClipDetailsWrapper = styled.div`
  padding: ${rem(12)};
`;
